import { useEffect, useState } from 'react'
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@cutilei/ui'
import LogInBusinessList from 'components/Lists/LogInBusinessList'

import {
  Container,
  Row,
  Column,
  InfoText,
  Button
} from './styles'

export default function SelectBusinessModal ({
  visible,
  businesses = [],
  selectedBusiness: selected = null,
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const [selectedBusiness, setSelectedBusiness] = useState (selected)

  useEffect (() => {
    setSelectedBusiness (selected)
  }, [selected])

  const handleSelect = async () => {
    if (!selectedBusiness) return

    handleConfirm (selectedBusiness)
    handleClose ()
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='md' aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Selecionar unidade</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Container>
            <InfoText>
              Selecione a unidade que deseja acessar
            </InfoText>
            <Column>
              <LogInBusinessList 
                businesses={businesses}
                selectedBusiness={selectedBusiness}
                onSelect={setSelectedBusiness}
              />
            </Column>
          </Container>
        </DialogBody>
        <DialogFooter>
          <Row>
            <Button type='button' onClick={handleSelect}>
              Confirmar
            </Button> 
          </Row>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
